import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

/** Components */
import ActionOverview from "./components/ActionOverview.vue";
import ActionDetail from "./components/ActionDetail.vue";
/** Components - END */

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueRouter);

Vue.config.productionTip = false;

const routes = [
  { path: "/", component: ActionOverview },
  { path: "/action/:id", component: ActionDetail },
];

const router = new VueRouter({
  routes,
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
